/* JR2 - scroll infinito progresivo con botón manual de respaldo. */
(function(){
  const initialized=new WeakSet();
  function init(){
    document.querySelectorAll('.jr2-collection-cards').forEach(function(section){
      const grid=section.querySelector('#product-grid'),pager=section.querySelector('.jr2-infinite-pagination');
      const sentinel=section.querySelector('.jr2-infinite-sentinel'),status=section.querySelector('.jr2-infinite-status');
      const more=section.querySelector('.jr2-infinite-more');
      if(!grid||!status||!more||!sentinel||initialized.has(grid))return;
      initialized.add(grid);
      if(!pager)return;
      let next=pager.dataset.jr2Next || pager.querySelector('a.pagination__item--prev')?.getAttribute('href') || '';
      if(!next)return;
      let busy=false,finished=false,observer=null,lastRequested='',failures=0;
      const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      more.hidden=false;
      more.addEventListener('click',load);
      function href(raw){
        const nextUrl=new URL(raw,location.origin);
        const current=new URL(location.href);
        const page=nextUrl.searchParams.get('page');
        if(page)current.searchParams.set('page',page);
        nextUrl.searchParams.forEach((v,k)=>{
          if(k!=='page')current.searchParams.set(k,v);
        });
        if(preview)current.searchParams.set('preview_theme_id',preview);
        return current.href;
      }
      function render(message){
        status.textContent=message||'';
        status.hidden=!message;
        more.hidden=finished||busy||!next;
        if(busy)more.disabled=true;else more.disabled=false;
        if(finished&&observer)observer.disconnect();
        pager.hidden=failures>0 ? false : true;
      }
      async function load(){
        if(busy||finished||!next)return;
        const request=href(next);
        if(request===lastRequested){finished=true;render('');return;}
        busy=true;
        render('Cargando más relojes…');
        try {
          const response=await fetch(request,{credentials:'same-origin'});
          if(!response.ok)throw new Error('HTTP '+response.status);
          const page=new DOMParser().parseFromString(await response.text(),'text/html');
          const incoming=page.querySelector('.jr2-collection-cards #product-grid')||page.querySelector('#product-grid');
          if(!incoming||!incoming.children.length)throw new Error('No hay productos en la respuesta');
          let added=0;
          const currentIds=new Set(Array.from(grid.children).map(li=>li.querySelector('a[href]')?.getAttribute('href')||''));
          Array.from(incoming.children).forEach(li=>{
            const key=li.querySelector('a[href]')?.getAttribute('href')||'';
            if(key&&currentIds.has(key))return;
            grid.appendChild(document.importNode(li,true));
            if(key)currentIds.add(key);
            added++;
          });
          const incomingPager=page.querySelector('.jr2-infinite-pagination');
          const newNext=incomingPager?.dataset.jr2Next||'';
          lastRequested=request;
          if(!added)throw new Error('No se añadieron productos');
          next=newNext;
          failures=0;
          if(!next)finished=true;
          busy=false;
          render('');
          if(!finished&&window.innerHeight+window.scrollY>=sentinel.getBoundingClientRect().top+window.scrollY-550)load();
        } catch(error){
          busy=false;failures++;
          render('No se pudo cargar automáticamente. Tocá «Cargar más relojes» para reintentar.');
          // Keep original Shopify pagination available on failure.
          pager.hidden=false;
          if(observer)observer.disconnect();
        }
      }
      if('IntersectionObserver' in window){
        observer=new IntersectionObserver(entries=>{
          if(entries.some(e=>e.isIntersecting))load();
        },{rootMargin:'0px 0px 650px 0px'});
        observer.observe(sentinel);
      } else {
        window.addEventListener('scroll',function(){
          if(!busy&&!finished&&sentinel.getBoundingClientRect().top<window.innerHeight+650)load();
        },{passive:true});
      }
      render('');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();